import * as React from "react";
import {useMemo, useState} from "react";
import {ILoginTabResponse} from "../../../../api/AdminAnalyticsApi";
import {applySort, SortDir} from "../../../../utils/listUtil";
import {getCountryName} from "../../../../utils/countryUtil";
import {sortTh} from "../shared/SortableTh.component";
import {CountryLoginMap} from "./CountryLoginMap.component";
import {numberWithCommas} from "../../../../utils/numberUtil";

interface ICountryLoginsSectionProps {
    countryLogins: ILoginTabResponse["countryLogins"];
    countryEngagement: ILoginTabResponse["countryEngagement"];
}

export const CountryLoginsSection: React.FC<ICountryLoginsSectionProps> = (props) => {
    const [countrySort, setCountrySort] = useState<{ col: string; dir: SortDir }>({col: "total", dir: "desc"});
    const sortedCountryLogins = useMemo(() => {
        const merged = props.countryLogins.map((row) => {
            const eng = props.countryEngagement.find((e) => e.country === row.country);
            return {...row, avgPages: eng ? eng.avgPagesPerUser : 0};
        });
        return applySort(merged, countrySort.col, countrySort.dir);
    }, [props.countryLogins, props.countryEngagement, countrySort]);

    return (
        <div>
            <h3 className="admin-analytics__subsection-title" style={{marginTop: 24}}>Logins by Country</h3>
            <div className="admin-analytics__country-row">
                <div className="admin-analytics__country-map-col">
                    <CountryLoginMap countryLogins={props.countryLogins}/>
                </div>
                <div className="admin-analytics__country-table-col">
                    <table className="admin-analytics__table">
                        <thead>
                        <tr>
                            {sortTh("country", "Country", countrySort, setCountrySort, undefined, "asc")}
                            {sortTh("internal", "Internal", countrySort, setCountrySort,
                                "admin-analytics__cell--right")}
                            {sortTh("external", "External", countrySort, setCountrySort,
                                "admin-analytics__cell--right")}
                            {sortTh("total", "Total", countrySort, setCountrySort,
                                "admin-analytics__cell--right")}
                            {sortTh("avgPages", "Avg Pages/Session", countrySort, setCountrySort,
                                "admin-analytics__cell--right")}
                        </tr>
                        </thead>
                        <tbody>{sortedCountryLogins.map((row) => (
                            <tr key={row.country}>
                                <td>{getCountryName(row.country)}</td>
                                <td className="admin-analytics__cell--right">{numberWithCommas(row.internal)}</td>
                                <td className="admin-analytics__cell--right">{numberWithCommas(row.external)}</td>
                                <td className="admin-analytics__cell--right">{numberWithCommas(row.total)}</td>
                                <td className="admin-analytics__cell--right">{row.avgPages ?? "-"}</td>
                            </tr>
                        ))}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
